import * as marietta from '../../..';
import * as marietta3d from '../../../../marietta3d';
import {ModelLoadSystem} from '../../../view3d/webcad/WebCad3dModelLoadSystem';
import { CEILING_FITTING_MAX_HEIGHT_MM } from '../../Constants';

// 天井高さの入力下限(mm)。部屋設定ダイアログと同じ範囲にそろえる
const CEILING_MIN_HEIGHT_MM: number = 1000;
const TENJO1F_SELECTOR: string = '#tenjo1f';
const TENJO2F_SELECTOR: string = '#tenjo2f';
const TENJO3F_SELECTOR: string = '#tenjo3f';
const FLOOR_3F: number = 3;
const INPUT_SELECTOR: string = 'input';
const LANGUAGE_JP: string = 'jp';
const ERROR_TITLE_KEY: string = 'ERROR_TITLE';
const createCeilingRangeMessageJp = (min: number, max: number): string => `基準天井高さには${min}mm以上、${max}mm以下の数値を入力してください。`;
const createCeilingRangeMessageEn = (min: number, max: number): string => `Please input from ${min}mm to ${max}mm for the basic ceiling height.`;

// Menu to change height of floors
export default class ChangeHeightMenu {
  data: marietta3d.AutoGen.ConstructionModel;

  height;

  viewObj;

  previousA: number;

  previousB: number;

  previousC: number;

  // 開いたときの天井高さ（変更されたときだけ上限チェックするため）
  private initialA1: number;

  private initialB1: number;

  private initialC1: number;

  /**
   * コンストラクタ
   */
  constructor() {
    this.viewObj = document.getElementById('itemChangeMenu_height');

    const self = this;
    document.getElementById('btnChangeModel3d').addEventListener('click', self.changeBtnEventHandler);
    document.getElementById('btnCancelModel3d').addEventListener('click', self.init);
  }

  /**
   * 初期設定
   */
  init = () => {
    // 情報をGET
    this.data = marietta.webcad.WebCADGlobal.autoMain.Model;
    this.height = marietta.webcad.WebCADGlobal.autoMain.GetDesignHigh();

    // 初期値
    this.previousA = this.height.A;
    this.previousB = this.height.B;
    this.previousC = this.height.C;
    this.initialA1 = Number(this.height.A1);
    this.initialB1 = Number(this.height.B1);
    this.initialC1 = Number(this.height.C1);

    // 階数に応じて表示する
    this.initFloors();

    // パラメータの表示を更新
    this.update();
  };

  /**
   * 表示するフロア設定
   */
  initFloors() {
    this.viewObj.querySelectorAll('.model3dParamsWrap').forEach((elem) => {
      elem.setAttribute('style', 'display : ""');
    });
    const highestFloor = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor();
    for (let i = 0; i < marietta.webcad.WebCADGlobal.MAX_FLOORS - highestFloor; i += 1) {
      this.viewObj.querySelectorAll('.model3dParamsWrap')[i].style.display = 'none';
    }
  }

  /**
   * ダイアログに表示するパラメータを更新
   */
  update() {
    const self = this;
    let $target;
    let textName: string;
    // height の更新
    for (let i = 0, keys = Object.keys(this.height); i < keys.length; i += 1) {
      switch (keys[i]) {
        case 'A': textName = 'height1f'; break;
        case 'A1': textName = 'tenjo1f'; break;
        case 'A2': textName = 'yukaatsu1f'; break;
        case 'B': textName = 'height2f'; break;
        case 'B1': textName = 'tenjo2f'; break;
        case 'B2': textName = 'yukaatsu2f'; break;
        case 'C': textName = 'height3f'; break;
        case 'C1': textName = 'tenjo3f'; break;
        case 'C2': textName = 'yukaatsu3f'; break;
        case 'D': textName = 'yukadaka1f'; break;
          // case "E": textName = "jihabakidaka"; break;
        case 'E1': textName = 'kisopakkin'; break;
        case 'E2': textName = 'kisodaka'; break;
        case 'F': textName = 'genkandaka'; break;
        default: textName = null; break;
      }
      if ((textName !== null || textName !== undefined) && !(this.height[keys[i]] instanceof Function)) {
        $target = this.viewObj.querySelector(`#${textName}`).querySelector('input');
        $target.value = this.height[keys[i]];

        $target.addEventListener('change', self.onInputChanged);
      }
    }

    // 各所の高さアップデート
    this.onInputChanged(null);
  }

  /**
   * 変更ボタンが押された
   */
  changeBtnEventHandler = () => {
    if (!this.validateCeilingHeights()) return;
    // 実行
    this.executeHeightChange();
  };

  /**
   * 天井高さの範囲チェック（変更された階だけ）。範囲外ならアラートを出して false
   */
  private validateCeilingHeights(): boolean {
    const A1: number = Number(this.viewObj.querySelector(TENJO1F_SELECTOR).querySelector(INPUT_SELECTOR).value);
    const B1: number = Number(this.viewObj.querySelector(TENJO2F_SELECTOR).querySelector(INPUT_SELECTOR).value);
    const C1: number = Number(this.viewObj.querySelector(TENJO3F_SELECTOR).querySelector(INPUT_SELECTOR).value);
    // 3Fの欄は3階建てのときだけ表示されるので、それ以外はチェックしない
    const has3F: boolean = marietta.webcad.WebCADGlobal.layerGroup.getHighestFloor() >= FLOOR_3F;
    const isOutOfRange = (value: number, initial: number): boolean => value !== initial && (value < CEILING_MIN_HEIGHT_MM || value > CEILING_FITTING_MAX_HEIGHT_MM);
    if (!isOutOfRange(A1, this.initialA1) && !isOutOfRange(B1, this.initialB1) && !(has3F && isOutOfRange(C1, this.initialC1))) return true;

    const message: string = (marietta.webcad.WebCADGlobal.language === LANGUAGE_JP)
      ? createCeilingRangeMessageJp(CEILING_MIN_HEIGHT_MM, CEILING_FITTING_MAX_HEIGHT_MM)
      : createCeilingRangeMessageEn(CEILING_MIN_HEIGHT_MM, CEILING_FITTING_MAX_HEIGHT_MM);
    marietta.webcad.WebCADGlobal.showAlert(message, marietta.webcad.collection.WebCADMessages.getText(ERROR_TITLE_KEY));
    return false;
  }

  /**
   * 変更のキャンセル
   */
  changeBtnEventHandlerCanceled = () => {
    // 入力値を元に戻す
    this.init();
  };

  /**
   * 高さ変更実行
   */
  executeHeightChange(): void {
    const self = this;
    // [3D] ConstructionModelに反映
    marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'), () => {
      setTimeout(() => {
        self.setParamConstructionModel();
      }, 500);
    });
  }

  /**
   * [3D] ConstructionModelに反映
   */
  setParamConstructionModel = () => {
    console.log(444);

    const A: number = Number(this.viewObj.querySelector('#height1f').querySelector('input').value);
    const A1: number = Number(this.viewObj.querySelector('#tenjo1f').querySelector('input').value);
    const A2: number = Number(this.viewObj.querySelector('#yukaatsu1f').querySelector('input').value);

    const B: number = Number(this.viewObj.querySelector('#height2f').querySelector('input').value);
    const B1: number = Number(this.viewObj.querySelector('#tenjo2f').querySelector('input').value);
    const B2: number = Number(this.viewObj.querySelector('#yukaatsu2f').querySelector('input').value);

    const C: number = Number(this.viewObj.querySelector('#height3f').querySelector('input').value);
    const C1: number = Number(this.viewObj.querySelector('#tenjo3f').querySelector('input').value);
    const C2: number = Number(this.viewObj.querySelector('#yukaatsu3f').querySelector('input').value);

    const D: number = Number(this.viewObj.querySelector('#yukadaka1f').querySelector('input').value);

    // var E:number = Number( $(this.viewObj).find('#jihabakidaka').find('input').val() );
    const E1: number = Number(this.viewObj.querySelector('#kisopakkin').querySelector('input').value);
    const E2: number = Number(this.viewObj.querySelector('#kisodaka').querySelector('input').value);

    const F: number = Number(this.viewObj.querySelector('#genkandaka').querySelector('input').value);

    marietta.webcad.WebCADGlobal.autoMain.SetDesignHigh(String(A), String(A1), String(A2), String(B), String(B1), String(B2), String(C), String(C1), String(C2), String(D), String(E1), String(E2), String(F));
    // 3D を作り直す前に UB を合わせ、仕様情報にも出す（この操作は履歴を積まない）
    marietta.webcad.WebCADGlobal.webcad2Dmanager.commitWithoutHistory();

    // 3Dのボタンの表示をデフォルトに戻す
    marietta.webcad.WebCADGlobal.init3dMenu();

    new ModelLoadSystem().request3D();

    // [2D] modelParamに反映
    this.setModelParamXML();

    // 変更フラグを立てる
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = true;

    // 3D内観ビューのカメラ情報を保持
    marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();

    // 建物形状の変更を行った時に外観カメラ位置を保持しておき
    marietta.view3d.webcad.View3dGlobal.shared.keepCameraState = true;

    // setが完了したらダイアログを閉じる
    marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
  };

  /**
   * [2D] modelParamに反映
   */
  setModelParamXML() {
    const jsonData = this.data.writeJSON();
    marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
  }

  /**
   * [2D] modelParamに反映
   */
  setModelParamXMLfrom2D() {
    const jsonData = marietta.webcad.WebCADGlobal.autoMain.Model.writeJSON();
    marietta.webcad.WebCADGlobal.setModelParamFromConstructionModel(jsonData);
  }

  /**
   * 入力値の補正
   */
  setValueLimitations(type: string): void {
    let A: number = Number(this.viewObj.querySelector('#height1f').querySelector('input').value);
    let A1: number = Number(this.viewObj.querySelector('#tenjo1f').querySelector('input').value);
    const A2: number = Number(this.viewObj.querySelector('#yukaatsu1f').querySelector('input').value);

    let B: number = Number(this.viewObj.querySelector('#height2f').querySelector('input').value);
    let B1: number = Number(this.viewObj.querySelector('#tenjo2f').querySelector('input').value);
    const B2: number = Number(this.viewObj.querySelector('#yukaatsu2f').querySelector('input').value);

    let C: number = Number(this.viewObj.querySelector('#height3f').querySelector('input').value);
    let C1: number = Number(this.viewObj.querySelector('#tenjo3f').querySelector('input').value);
    const C2: number = Number(this.viewObj.querySelector('#yukaatsu3f').querySelector('input').value);

    let D: number = Number(this.viewObj.querySelector('#yukadaka1f').querySelector('input').value);

    // var E:number = Number( $(this.viewObj).find('#jihabakidaka').find('input').val() );
    let E1: number = Number(this.viewObj.querySelector('#kisopakkin').querySelector('input').value);
    let E2: number = Number(this.viewObj.querySelector('#kisodaka').querySelector('input').value);

    let F: number = Number(this.viewObj.querySelector('#genkandaka').querySelector('input').value);

    switch (type) {
      case 'height1f': // "A":
        if (A < 2100) A = 2100;
        if (A > 8000) A = 8000;
        break;
      case 'tenjo1f': // "A1":
        if (A1 <= 0) A1 = 2400; // 3.5.0
        //    if( A-D < A1 ) A1 = A-D;
        break;
      // case "yukaatsu1f":    //"A2":
      //    if( A2 < 12 ) A2 = 12;
      //    if( D-E1-E2 < A2 ) A2 = D-E1-E2;
      //    break;
      case 'height2f': // "B":
        if (B < 10) B = 10;
        if (B > 4000) B = 4000;
        break;
      case 'tenjo2f': // "B1":
        //    if( B-B2 < B1 ) B1 = B-B2;
        if (B1 <= 0) B1 = 2400; // 3.5.0
        break;
      // case "yukaatsu2f":  //"B2":
      //    if( B2 < 12 ) B2 = 12;
      //    if( B-B1 < B2 ) B2 = B-B1;
      //    break;
      case 'height3f': // "C":
        if (C < 10) C = 10;
        if (C > 4000) C = 4000;
        break;
      case 'tenjo3f': // "C1":
        if (C1 <= 0) C1 = 2400; // 3.5.0
        //    if( C-C2 < C1 ) C1 = C-C2;
        break;
      // case "yukaatsu3f":  //"C2":
      //    if( C2 < 12 ) C2 = 12;
      //    if( C-C1 < C2 ) C2 = C-C1;
      //    break;
      case 'yukadaka1f': // "D":
        if (D < 420) D = 420;
        if (A - A2 < D) D = A - A2;
        break;
      case 'kisopakkin': // "E1":
        if (E1 < 0) E1 = 0;
        if (E1 > 40) E1 = 40;
        break;
      case 'kisodaka': // "E2":
        if (E2 < 0) E2 = 0;
        if (D - A2 - E1 < E2) E2 = D - A2 - E1;
        break;
      case 'genkandaka': // "F":
        if (D - 180 < F) F = D - 180;
        if (F < 0) F = 0;
        break;
      default:
        break;
    }

    this.setValueToScreen(A, A1, A2, B, B1, B2, C, C1, C2, D, E1, E2, F);
  }

  /**
   * 入力ボックスのID取得
   */
  getParentID = (element: Element): string => {
    while (element.parentElement != null) {
      if (element.className === 'modelParamHeight') {
        return element.getAttribute('id');
      }
      // eslint-disable-next-line no-param-reassign
      element = element.parentElement;
    }
    return null;
  };

  /**
   * 入力値が変更された
   */
  onInputChanged = (event: Event = null) => {
    const self: ChangeHeightMenu = this;

    if (event != null) {
      self.setValueLimitations(self.getParentID(event.currentTarget as HTMLInputElement));
    }

    let A: number = Number(this.viewObj.querySelector('#height1f').querySelector('input').value);
    let A1: number = Number(this.viewObj.querySelector('#tenjo1f').querySelector('input').value);
    const A2: number = Number(this.viewObj.querySelector('#yukaatsu1f').querySelector('input').value);

    let B: number = Number(this.viewObj.querySelector('#height2f').querySelector('input').value);
    let B1: number = Number(this.viewObj.querySelector('#tenjo2f').querySelector('input').value);
    const B2: number = Number(this.viewObj.querySelector('#yukaatsu2f').querySelector('input').value);

    let C: number = Number(this.viewObj.querySelector('#height3f').querySelector('input').value);
    let C1: number = Number(this.viewObj.querySelector('#tenjo3f').querySelector('input').value);
    const C2: number = Number(this.viewObj.querySelector('#yukaatsu3f').querySelector('input').value);

    let D: number = Number(this.viewObj.querySelector('#yukadaka1f').querySelector('input').value);

    // var E:number = Number( $(this.viewObj).find('#jihabakidaka').find('input').val() );
    let E1: number = Number(this.viewObj.querySelector('#kisopakkin').querySelector('input').value);
    let E2: number = Number(this.viewObj.querySelector('#kisodaka').querySelector('input').value);

    let F: number = Number(this.viewObj.querySelector('#genkandaka').querySelector('input').value);

    // 制限値
    if (A < 2100) A = 2100;
    if (A1 <= 0) A1 = 2400; // 3.5.0
    // if( A2 < 0 ) A2 = 0;

    if (B < 10) B = 10;
    if (B1 <= 0) B1 = 2400; // 3.5.0
    // if( B2 < 0 ) B2 = 0;

    if (C < 10) C = 10;
    if (C1 <= 0) C1 = 2400; // 3.5.0
    // if( C2 < 0 ) C2 = 0;

    if (A > 8000) A = 8000;
    // if( A-D < A1 ) A1 = A-D;
    // if( D-E1-E2 < A2 ) A2 = D-E1-E2;

    if (B > 4000) B = 4000;
    // if( B-B2 < B1 ) B1 = B-B2;
    // if( B-B1 < B2 ) B2 = B-B1;

    if (C > 4000) C = 4000;
    // if( C-C2 < C1 ) C1 = C-C2;
    // if( C-C1 < C2 ) C2 = C-C1;

    if (D < 420) D = 420;
    if (A - A2 < D) D = A - A2;

    if (event != null && self.getParentID(event.currentTarget as HTMLInputElement) === 'yukadaka1f') {
      F = D - 180;
    }

    if (E1 < 0) E1 = 0;
    if (E1 > 40) E1 = 40;
    if (E2 < 0) E2 = 0;
    if (D - A2 - E1 < E2) E2 = D - A2 - E1;

    if (D - 180 < F) F = D - 180;
    if (F < 0) F = 0;

    self.setValueToScreen(A, A1, A2, B, B1, B2, C, C1, C2, D, E1, E2, F);
  };

  /**
   * 入力値の補正
   */
  setValueToScreen(A: number, A1: number, A2: number, B: number, B1: number, B2: number, C: number, C1: number, C2: number, D: number, E1: number, E2: number, F: number): void {
    // 値の際代入
    this.viewObj.querySelector('#height1f').querySelector('input').value = String(A);
    this.viewObj.querySelector('#tenjo1f').querySelector('input').value = String(A1);
    this.viewObj.querySelector('#yukaatsu1f').querySelector('input').value = String(A2);

    this.viewObj.querySelector('#height2f').querySelector('input').value = String(B);
    this.viewObj.querySelector('#tenjo2f').querySelector('input').value = String(B1);
    this.viewObj.querySelector('#yukaatsu2f').querySelector('input').value = String(B2);

    this.viewObj.querySelector('#height3f').querySelector('input').value = String(C);
    this.viewObj.querySelector('#tenjo3f').querySelector('input').value = String(C1);
    this.viewObj.querySelector('#yukaatsu3f').querySelector('input').value = String(C2);

    this.viewObj.querySelector('#yukadaka1f').querySelector('input').value = String(D);

    // $(this.viewObj).find('#jihabakidaka').find('input').val(String(E));
    this.viewObj.querySelector('#kisopakkin').querySelector('input').value = String(E1);
    this.viewObj.querySelector('#kisodaka').querySelector('input').value = String(E2);

    this.viewObj.querySelector('#genkandaka').querySelector('input').value = String(F);

    console.log(this.viewObj.querySelector('#nokidaka3f').querySelector('dd').innerHTML);
    // 逆算して計算するところ
    this.viewObj.querySelector('#nokidaka3f').querySelector('dd').innerHTML = String(A + B + C);
    // $(this.viewObj).find('#tenjo3f').find("dd").html( String( C - (335+40) ) );
    this.viewObj.querySelector('#nokidaka2f').querySelector('dd').innerHTML = String(A + B);
    // $(this.viewObj).find('#tenjo2f').find("dd").html( String( B - (355+40) ) );
    this.viewObj.querySelector('#nokidaka1f').querySelector('dd').innerHTML = String(A);
    // $(this.viewObj).find('#tenjo1f').find("dd").html( String( A  - D - 415 ) );
  }

  /**
   * プランデータを更新
   */
  setPlanXML = () => {
    // XML作成
    const xml = marietta.webcad.WebCADGlobal.webcad2Dmanager.getSaveData();
    // eslint-disable-next-line camelcase
    const xml_serializer = new XMLSerializer();
    const xmlString = xml_serializer.serializeToString(xml);

    // 3D側にXML受け渡し
    marietta.webcad.WebCADGlobal.autoMain.perseXML(xmlString);
  };
}
